<template>
    <div>
        <button 
            v-if="showComponent && enabled"
            title="Please Subscribe for Receive Notifications of ERPeach"
            class="btn btn-link btn-sm"
            @click.prevent="susbcribe"
            style="text-decoration:none"
        >
            <i class="fa fa-bell"></i>
        </button>
    
        <ks-modal
            :ref="`npiModal${_uid}`"
            position="centered"
            :backdropClose="false"
            title="Notifications Blocked"
        >
            <ks-modal-body
                style="display:flex;"
            >
                <img :src="require('../../assets/images/notifications-instructions.png')" style="width:100%"/>
            </ks-modal-body>
      </ks-modal>
    
    </div>
    </template>
    <script>
    import checkPermissions from '../../mixins/checkPermissions';
    export default {
        name:"ks-notification-subscription-button",
        mixins: [checkPermissions],
        computed:{
            enabled(){
                return window.app.notificationPromt && app.auth.user.lts ? true : false;
            }
        },
        methods:{
            async susbcribe(){
                window.app.notificationPromt.requestPermission()
                .then(result => {
                    if (result === 'granted') {
                        window.app.notificationPromt = null;
                    }else{
                        this.$refs[`npiModal${this._uid}`].show();
                    }
                })
                .catch(err =>{
                    this.$refs[`npiModal${this._uid}`].show();
                });
            }
        }
    }
    </script>